import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError() {
    return {hasError: true}
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="page-wrapper">
          <div className="content d-flex align-items-center justify-content-center" style={{minHeight: '80vh'}}>
            <div className="d-flex flex-column align-items-center">
              <h1>Kutilmagan xatolik!</h1>
              <h4>Sahifani qayta yuklang.</h4>
              <button className="btn badge-primary" onClick={() => window.location.reload()}>
                Qayta yuklash
              </button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
